import React, { useMemo } from "react";
import { Box } from "@mui/material";

import CheckinCard from "./CheckinCard";

const CheckinsCarousel = ({ items, onOpen }) => {
  const safeItems = useMemo(() => items?.slice(0, 3) ?? [], [items]);

  if (safeItems.length === 0) return null;

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          width: "100%",
          maxWidth: 980,
          mx: 0,
          px: { xs: 0, sm: 0 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            flexWrap: { xs: "nowrap", sm: "wrap", md: "nowrap" },
            gap: { xs: 2, sm: 3 },
            alignItems: "stretch",
            justifyContent: "flex-start",
            width: "100%",
          }}
        >
          {safeItems.map((item) => (
            <Box
              key={item.dialogType}
              sx={{
                flex: { xs: "1 1 auto", sm: "0 1 320px", md: "1 1 0" },
                maxWidth: { xs: "100%", sm: "320px", md: "none" },
                display: "flex",
              }}
            >
              <Box sx={{ width: "100%" }}>
                <CheckinCard item={item} onOpen={onOpen} />
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CheckinsCarousel;
